import React from 'react';

const PostRetirementBottomline = () => {
  const benefits = [
    {
      title: "Income Stability Engineering",
      description: "Our post-retirement solutions create reliable income streams calibrated to your lifestyle needs, combining guaranteed sources with flexible withdrawals to ensure consistent cash flow regardless of market conditions."
    },
    {
      title: "Longevity Protection",
      description: "Advanced planning techniques address the 'risk' of a long life, ensuring your assets sustain you throughout your entire retirement journey, even if you live well into your 90s or beyond."
    },
    {
      title: "Healthcare Expense Management",
      description: "Specialized strategies help insulate your retirement from potentially devastating healthcare costs, preserving your wealth despite increasing medical expenses and long-term care needs."
    },
    {
      title: "Dynamic Adaptation Framework",
      description: "Our approach includes regular recalibration of your plan to account for changing market conditions, personal circumstances, and evolving goals, ensuring continued financial security through every phase of retirement."
    }
  ];

  return (
    <div className="w-full bg-gradient-to-br from-[#113262] to-[#1C52A0] py-12 px-8">
      <div className="max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 lg:py-8">
        <div className="text-center mb-16">
          <h2 className="text-white text-2xl md:text-3xl lg:text-4xl font-bold mb-4">
            Bottomline: Benefits of Our Post-Retirement Solutions
          </h2>
          <div className="w-24 h-1 bg-[#F49611] mx-auto mt-4"></div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16">
          {benefits.map((benefit, index) => (
            <div key={index} className="relative">
              {/* Decorative number */}
              <div className="absolute -left-8 top-0 text-6xl font-bold text-[#F49611] opacity-10">
                {index + 1}
              </div>
              
              {/* Content */}
              <div className="relative">
                <div className="flex items-start space-x-4">
                  {/* Vertical line decoration */}
                  <div className="hidden md:block w-1 h-full bg-gradient-to-b from-[#F49611] to-transparent"></div>
                  
                  <div className="flex-1">
                    <h3 className="text-[#F49611] text-xl font-semibold mb-4">
                      {benefit.title}
                    </h3>
                    <p className="text-white/80 text-base leading-relaxed">
                      {benefit.description}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PostRetirementBottomline;